var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              link: "page-historical-figures",
                              title: _vm.getTitle
                                ? `Редактировать ${_vm.getTitle}`
                                : `Добавить историческую личность`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c("InputTitleSlug", {
                                    attrs: {
                                      "is-loading": _vm.loading,
                                      title: _vm.fields.name,
                                      "title-error": _vm.validationErrors.name,
                                      slug: _vm.fields.slug,
                                      "slug-error": _vm.validationErrors.slug,
                                      isSlugEnabled: !_vm.isNew,
                                    },
                                    on: {
                                      "change:title": function ($event) {
                                        _vm.fields.name = $event
                                      },
                                      "change:slug": function ($event) {
                                        _vm.fields.slug = $event
                                      },
                                      "input:slug": _vm.$v.fields.slug.$touch,
                                    },
                                  }),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Краткое описание"),
                                          ]),
                                          _c("v-textarea", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.excerpt,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "excerpt",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.excerpt",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c("QuillEditorVue", {
                                        attrs: {
                                          cols: 12,
                                          content: _vm.fields.description,
                                          loading: _vm.loading,
                                          disabled: _vm.loading,
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.fields.description = $event
                                          },
                                          onChangeContent: function ($event) {
                                            return _vm.$emit(
                                              "change:descriptionForMobile",
                                              { fields: _vm.fields, $event }
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Видео url")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.videoUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "videoUrl",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.videoUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("MediaFilePicker", {
                                            attrs: {
                                              label: "Миниатюра",
                                              multiple: false,
                                              "file-type":
                                                _vm.$options.mediaTypesByKeys
                                                  .IMAGE,
                                              value: _vm.fields.thumbnailId,
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.fields.thumbnailId = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("MediaFilePicker", {
                                            attrs: {
                                              label: "Обложка",
                                              multiple: false,
                                              "file-type":
                                                _vm.$options.mediaTypesByKeys
                                                  .IMAGE,
                                              value: _vm.fields.coverId,
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.fields.coverId = $event
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Расположение")]),
                                          _c("LocationAutocomplete", {
                                            attrs: {
                                              address: _vm.fields.location,
                                              loading: _vm.loading,
                                            },
                                            on: {
                                              "set-location": _vm.setLocation,
                                              "update-location-part":
                                                _vm.updateLocation,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("SeoSettings", {
                                            attrs: {
                                              data: _vm.data,
                                              loading: _vm.loading,
                                            },
                                            on: {
                                              "on-input-seo": function (
                                                $event
                                              ) {
                                                _vm.fields = Object.assign(
                                                  {},
                                                  _vm.fields,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    attrs: {
                      isShowSortOrder: "",
                      isNew: _vm.isNew,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.getDataId,
                      "entity-type": "historicalFigure",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-historicalFigure")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({
                          name: "page-historical-figures",
                        })
                      },
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-card",
                              { attrs: { flat: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "grey--text" },
                                  [_vm._v(" Связи ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    !!_vm.cities
                                      ? _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Город")]),
                                            _c("v-select", {
                                              attrs: {
                                                outlined: "",
                                                "no-data-text": "Список пуст",
                                                "item-value": "id",
                                                "item-text": "title",
                                                multiple: "",
                                                value: _vm.fields.cities,
                                                items: _vm.cities,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.fields.cities = $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    !!_vm.places
                                      ? _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Места")]),
                                            _c("v-select", {
                                              attrs: {
                                                outlined: "",
                                                "no-data-text": "Список пуст",
                                                "item-value": "id",
                                                "item-text": "title",
                                                multiple: "",
                                                value: _vm.fields.places,
                                                items: _vm.places,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.fields.places = $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }